<template>
  <v-sheet tile class="fill-height profile-page">
    <v-list two-line>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-subtitle>NAME</v-list-item-subtitle>
          <v-list-item-title>{{
            currentUser.attributes.name
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-divider inset></v-divider> -->
      <!-- <v-list-item >
        <v-list-item-content>
          <v-list-item-subtitle>PHONE</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>  -->
      <v-list-item-subtitle class="ml-4 mr-4 mb-2 mt-4 text--secondary"
        >PHONE</v-list-item-subtitle
      >
      <VuePhoneNumberInput
        maxlength="16"
        type="tel"
        class="mt-0 ml-4 mr-4 "
        v-model="phone"
        :default-country-code="countryCodeShort"
        @update="results = $event"
      />

      <!-- <v-list-item>
        <v-list-item-content>
          <v-text-field
            label="Phone"
            maxlength="16"
            type="tel"
            v-model="phone"
          ></v-text-field>
        </v-list-item-content>
      </v-list-item> -->

      <v-list-item class="mt-4">
        <v-list-item-content>
          <v-list-item-subtitle>NOTIFICATION</v-list-item-subtitle>
          <v-container class=" mt-0">
            <v-row class="dark--text" fluid>
              <v-switch
                class="ml-2 mr-4 mt-0"
                v-model="emailSwitch"
                color="primary"
                label="Email"
              ></v-switch>
              <v-switch
                class="ml-4 mr-4 mt-0"
                v-model="smsSwitch"
                color="primary"
                label="Sms"
              ></v-switch>
              <v-switch
                class="ml-4 mr-4 mt-0"
                v-model="pushSwitch"
                color="primary"
                label="Push"
              ></v-switch>
            </v-row>
          </v-container>
          <v-btn depressed color="primary" v-on:click="saveSetting">
            Save
          </v-btn>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-container v-if="switchAvailable">
      <v-list three-line subheader>
        <v-form v-model="isValid">
          <v-select
            background-color="#F4F7FC"
            filled
            required
            label="Role"
            v-model="role"
            :items="possibleRoles"
            @change="clearItem"
            item-value="name"
            :rules="[v => !!v || 'Please select a value']"
            item-text="display_name"
            loader-height="0"
            loading
          >
            <template slot="prepend-inner">
              <v-icon color="primary" class="mr-2">compare_arrows</v-icon>
            </template>
            <template slot="append">
              <v-icon color="primary">keyboard_arrow_down</v-icon>
            </template>
          </v-select>
          <v-select
            background-color="#F4F7FC"
            filled
            required
            :label="itemsCaption"
            v-if="should_select_item"
            v-model="item_id"
            :rules="[v => !!v || 'Please select a value']"
            :items="availableItems"
            item-value="id"
            item-text="name"
            loader-height="0"
            loading
          >
            <template slot="prepend-inner">
              <v-icon color="primary" class="mr-2">local_offer</v-icon>
            </template>
            <template slot="append">
              <v-icon color="primary">keyboard_arrow_down</v-icon>
            </template>
          </v-select>
          <v-btn
            block
            outlined
            color="primary"
            @click="setRole"
            :disabled="!isValid"
            >Switch Role</v-btn
          >
        </v-form>
      </v-list>
    </v-container>
    <v-container class="pt-0">
      <FullscreenModalWithSlot
        v-if="isSuperAdmin"
        :dense="true"
        :persistent="false"
        @opened="toggleOverlay"
        @closed="toggleOverlay"
        :closing_btn_disabled="!isValidForGen"
        @closed_primary="generateFakeData"
      >
        <!--:-->
        <!---->

        <template v-slot:activator>
          <v-btn block large color="primary" outlined>
            <v-icon left>insights</v-icon>
            Generate Dashboard Data
          </v-btn>
        </template>
        <template v-slot:content>
          <v-card tile flat>
            <v-card-title>Generate Data For</v-card-title>
            <v-form v-model="isValidForGen" style="position: relative">
              <v-select
                class="ma-3"
                background-color="#F4F7FC"
                filled
                required
                label="Brand"
                hide-details
                @change="clearSelectedStore"
                v-model="selected_brand_id"
                :rules="[v => !!v || 'Please select a value']"
                :items="allBrands"
                item-value="id"
                item-text="name"
                loader-height="0"
                loading
              >
                <template slot="prepend-inner">
                  <v-icon color="primary" class="mr-2">local_offer</v-icon>
                </template>
                <template slot="append">
                  <v-icon color="primary">keyboard_arrow_down</v-icon>
                </template>
              </v-select>
              <div v-if="selected_brand_id">
                <v-select
                  class="mx-3 mb-3"
                  background-color="#F4F7FC"
                  filled
                  required
                  :label="fieldLabel"
                  v-model="storeToFill"
                  hide-details
                  :rules="[v => !!v || 'Please select a value']"
                  :items="allStoresInSelectedBrand"
                  item-value="id"
                  item-text="name"
                  loader-height="0"
                  loading
                >
                  <template slot="prepend-inner">
                    <v-icon color="primary" class="mr-2">local_offer</v-icon>
                  </template>
                  <template slot="append">
                    <v-icon color="primary">keyboard_arrow_down</v-icon>
                  </template>
                </v-select>
              </div>
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    loader-height="0"
                    loading
                    hide-details
                    class="mx-3"
                    background-color="#F4F7FC"
                    filled
                    required
                    :value="formattedDate(startDate)"
                    label="Start Date"
                    readonly
                    v-bind="attrs"
                    :rules="[
                      v => !!v || 'Please select a value',
                      v => v > endDate || 'Start Date is after End Date'
                    ]"
                    v-on="on"
                  >
                    <template slot="prepend-inner">
                      <v-icon color="primary" class="mr-2">today</v-icon>
                    </template>
                    <template slot="append">
                      <v-icon color="primary">keyboard_arrow_down</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="startDate"
                  @input="menu2 = false"
                ></v-date-picker>
              </v-menu>
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    loader-height="0"
                    loading
                    hide-details
                    class="mx-3 mt-3"
                    background-color="#F4F7FC"
                    filled
                    required
                    :value="formattedDate(endDate)"
                    label="End Date"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template slot="prepend-inner">
                      <v-icon color="primary" class="mr-2">event</v-icon>
                    </template>
                    <template slot="append">
                      <v-icon color="primary">keyboard_arrow_down</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  color="primary"
                  v-model="endDate"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
              <p class="text-center my-1 subtitle-2">
                Type of Users to Generate
              </p>
              <v-btn-toggle
                class="d-flex justify-center"
                mandatory
                v-model="usersToGenerate"
                color="primary"
                group
              >
                <v-btn outlined value="new">
                  New
                </v-btn>
                <v-btn value="existing">
                  Existing
                </v-btn>
                <v-btn value="both">
                  Both
                </v-btn>
              </v-btn-toggle>
              <v-text-field
                class="mx-3 mt-3"
                background-color="#F4F7FC"
                filled
                required
                label="Reservations Amount"
                hint="Up to 4 digits"
                v-model.number="reservationsToGenerate"
                :rules="[v => !!v || 'Please select a value']"
                loader-height="0"
                loading
                v-mask="'####'"
              >
              </v-text-field>
            </v-form>
          </v-card>
        </template>
        <template v-slot:closing-btn-title>
          Generate
        </template>
      </FullscreenModalWithSlot>
      <v-overlay v-model="overlay"></v-overlay>
    </v-container>
    <v-spacer></v-spacer>
    <v-container>
      <div class="buttons-attributes">
        <v-btn color="primary" outlined :to="{ name: PAGE_IDS.HOW_IT_WORKS }"
          >Help</v-btn
        >
        <v-btn color="primary" outlined :to="{ name: PAGE_IDS.PRIVACY_PAGE }"
          >Privacy</v-btn
        >
        <v-btn color="primary" outlined @click="changePassword">Password</v-btn>
        <v-btn color="primary" outlined @click="logout">Logout</v-btn>
      </div>
    </v-container>
    <v-snackbar top color="white" v-model="snackbar">
      <span class="primary--text"
        >Your Information Updated Successfully
        <!-- <v-chip color="primary" label>{{  }}</v-chip> -->
      </span>
    </v-snackbar>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
import { AmplifyEventBus } from "aws-amplify-vue";
import { PAGE_IDS } from "@/utils/constants";
import DetailsFullscreen from "../Elements/DetailsFullscreen";
import FullscreenModalWithSlot from "../Elements/FullscreenModalWithSlot";
import { createUserInfo, updateUserInfo } from "../graphql/mutations";
import { getUserInfo } from "../graphql/queries";
import VuePhoneNumberInput from "vue-phone-number-input";

const moment = require("moment-timezone");
export default {
  name: "Profile",
  components: {
    FullscreenModalWithSlot,
    DetailsFullscreen,
    VuePhoneNumberInput
  },
  data: function() {
    return {
       snackbar: false,
      menu2: false,
      menu1: false,
      role: undefined,
      item_id: undefined,
      isValid: false,
      isValidForGen: false,
      selected_brand_id: undefined,
      overlay: false,
      emailSwitch: true,
      smsSwitch: true,
      pushSwitch: true,
      phone: "",
      countryCodeShort:"US",
      email: "",
      // phoneNumber: null,
      results: null
    };
  },
  computed: {
    ...mapGetters([
      "isSuperAdmin",
      "loadingState",
      "getBrandById",
      "getStartDate",
      "getEndDate",
      "getStoreToFill",
      "getUsersToGenerate",
      "getReservationsToGenerateNum",
      "allStores",
      "allBrands",
      "switchAvailable",
      "currentUser",
      "groupName",
      "getDefaultPage",
      "currentRole",
      "possibleRoles",
      "getCurrentBrand",
      "getCurrentStore"
    ]),
    fieldLabel() {
      return `Brand: ${this.getBrandById(this.selected_brand_id).name}`;
    },
    storeToFill: {
      get() {
        return this.getStoreToFill;
      },
      set(id) {
        this.$store.dispatch("updateStoreId", id);
      }
    },
    startDate: {
      get() {
        return this.getStartDate;
      },
      set(date) {
        this.$store.dispatch("updateStartDate", date);
      }
    },
    endDate: {
      get() {
        return this.getEndDate;
      },
      set(date) {
        this.$store.dispatch("updateEndDate", date);
      }
    },
    usersToGenerate: {
      get() {
        return this.getUsersToGenerate;
      },
      set(num) {
        this.$store.dispatch("updateUsersToGenerate", num);
      }
    },
    reservationsToGenerate: {
      get() {
        return this.getReservationsToGenerateNum;
      },
      set(num) {
        this.$store.dispatch("updateReservationsToGenerate", num);
      }
    },

    allStoresInSelectedBrand() {
      let filtered_stores = this.allStores.filter(
        item => item.brand_id === this.selected_brand_id
      );
      if (filtered_stores.length) {
        let all_stores = {
          name: "All Stores",
          id: filtered_stores.map(item => item.id)
        };
        return [all_stores, ...filtered_stores];
      } else {
        return filtered_stores;
      }
    },
    itemsCaption() {
      if (this.role == "Brand Manager") {
        return "Brand";
      }
      return "Store";
    },
    should_select_item() {
      if (
        this.role == "Brand Manager" ||
        this.role == "Store Manager" ||
        this.role == "Security"
      ) {
        return true;
      }
      return false;
    },
    availableItems() {
      var results = [];
      if (
        this.role == "Brand Manager" ||
        this.role == "Store Manager" ||
        this.role == "Security"
      ) {
        return this.possibleRoles.find(item => item.name == this.role).items;
      }
      return [];
    }
  },
  beforeMount() {
    this.getOwner();
  },
  mounted() {
    this.$store.dispatch("reloadBrandsStores");
    this.role = this.currentRole;
    if (this.role == "Brand Manager") {
      this.item_id = this.getCurrentBrand;
    }
    if (this.role == "Store Manager" || this.role == "Security") {
      this.item_id = this.getCurrentStore;
    }
  },
  methods: {
    generateFakeData() {
      this.$store.dispatch("generateData").then(() => {});
    },
    formattedDate(date) {
      if (date) {
        return moment(date).format("dddd, MMMM Do YYYY");
      } else {
        return "";
      }
    },
    clearSelectedStore() {
      this.$store.dispatch("updateStoreId", undefined);
    },
    toggleOverlay() {
      this.overlay = !this.overlay;
    },
    clearItem() {
      this.item_id = undefined;
    },
    setRole() {
      this.$store.dispatch("setRole", {
        role: this.role,
        item_id: this.item_id
      });
      this.$router.push(this.getDefaultPage);
    },

    getOwner() {
      try {
        this.$Amplify.API.graphql(
          this.$Amplify.graphqlOperation(getUserInfo, {
            owner: this.$store.getters.currentOwnerId
          })
        )
          .then(res => {
            console.log("User information data : ", res);
            this.email = res.data.getUserInfo.email;
            this.emailSwitch = res.data.getUserInfo.receiveEmail;
            this.smsSwitch = res.data.getUserInfo.receiveSMS;
            this.pushSwitch = res.data.getUserInfo.receivePush;
            this.countryCodeShort = res.data.getUserInfo.countryShortCode !== "null" &&   res.data.getUserInfo.countryShortCode !== "" ? res.data.getUserInfo.countryShortCode
                : "US";
            this.phone =
              res.data.getUserInfo.phone !== "null" &&
              res.data.getUserInfo.phone !== ""
                ? res.data.getUserInfo.phone
                : "";
            // res.data.getUserInfo
          })
          .catch(e => {});
      } catch (error) {}
    },
    saveSetting() {
      // console.log("result is phone : ", this.phoneNumber)
      // console.log("result is : ", this.results.formattedNumber)
      // console.log("result : ",this.results);

      try {
        this.phone = this.results.formattedNumber;
        this.countryCodeShort = this.results.countryCode;

      } catch (error) {
          this.phone ="";
      }
      
      try {
        this.updateUserInformation(
          this.email,
          this.$store.getters.currentOwnerId,
          this.phone.trim(),
          this.countryCodeShort,
          this.pushSwitch,
          this.emailSwitch,
          this.smsSwitch
        );
      } catch (error) {
        console.log("error : ",error);
      }
    },
    updateUserInformation(
      email,
      cognitoUserName,
      phone,
      countryCodeShort,
      receivePush,
      receiveEmail,
      receiveSMS
    ) {
      this.$store.dispatch("startLoading");
      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(updateUserInfo, {
          input: {
            email: email,
            owner: cognitoUserName,
            phone: phone,
            countryShortCode:countryCodeShort,
            receivePush: receivePush,
            receiveEmail: receiveEmail,
            receiveSMS: receiveSMS,
            // createdAt: new Date().toISOString(),
            updatedAt: new Date().toISOString()
          }
        })
      )
        .then(res => {
          this.snackbar = true;
          this.$store.dispatch("stopLoading");

        })
        .catch(e => {
          this.$store.dispatch("stopLoading");
          process_api_error(`Error Creating Create User information`, e);
        });
    },
    logout() {
      this.$Amplify.Auth.signOut().then(() => {
        return AmplifyEventBus.$emit("authState", "signedOut");
      });
    },
    changePassword() {
      this.$router.push({ name: PAGE_IDS.CHANGE_PASSWORD });
    }
  }
};
</script>

<style lang="scss" scoped>
.profile-page {
  display: grid;
  grid-template-rows: auto auto 1fr auto;
}

.v-list-item__subtitle {
  font-size: 0.675rem;
  font-weight: 600;
  letter-spacing: 1.1px;
}

.buttons-attributes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  @media screen and (min-width: 599px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}

.attributes {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;
  @media screen and (min-width: 599px) {
    grid-column-gap: 3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/Pages/Profile.vue